import { render } from "./CorporateFooter.vue?vue&type=template&id=0986f29e&scoped=true"
import script from "./CorporateFooter.vue?vue&type=script&lang=js"
export * from "./CorporateFooter.vue?vue&type=script&lang=js"

import "./CorporateFooter.vue?vue&type=style&index=0&id=0986f29e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0986f29e"]])

export default __exports__